var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{attrs:{"app-data":"true"}},[_c('div',[(_vm.isAllUIConfigurationsLoaded)?_c('router-view'):_c('div',[_vm._v("App Loading....")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }